import { SvgIcon, type SvgIconProps } from '@mui/material';

const NextPaginationItemSvg = (properties: SvgIconProps) => (
  <SvgIcon {...properties}>
    <svg
      fill="none"
      height="12"
      viewBox="0 0 7 12"
      width="7"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.78 6.72A.75.75 0 0 0 7 6.19v-.38a.77.77 0 0 0-.22-.53L1.64.15a.5.5 0 0 0-.71 0L.22.86a.49.49 0 0 0 0 .7L4.67 6 .22 10.44a.5.5 0 0 0 0 .71l.71.7a.5.5 0 0 0 .71 0z"
        fill="currentColor"
      />
    </svg>
  </SvgIcon>
);

export default NextPaginationItemSvg;
